// @ts-nocheck
/* eslint-disable @typescript-eslint/no-empty-function */
import React, {
  FunctionComponent,
  useState,
  useRef,
  useMemo,
  useEffect,
} from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Select from 'react-select'
import { useMediaQuery } from 'react-responsive'
import {
  genreAddedEventSchedulingCampaign,
  genreRemovedEventSchedulingCampaign,
  locationEvent,
} from 'Helpers/tagManager'
import { getUserId, getIsFirstCampaign } from 'Redux/selectors/auth'
import {
  getAmountOfCampaigns,
  getCampaignToSchedule,
} from 'Redux/selectors/campaigns'
import {
  ActionsForSelectGenresAndLanguagesEnum,
  CampaignToSchedule,
} from 'Types/index'
import { useContainerSize } from 'Constants/functions'
import { DropdownIndicator } from 'Shared/components/DropdownIndicator'
import MenuList from 'Shared/components/MenuList'
import {
  customStyles,
  mobileCustomStyles,
} from 'Shared/components/CustomStyles'
import { IconCheckMark } from 'Stories/Icon/Icon.stories'
import { SelectGenresProps } from './SelectGenresProps'

import {
  IconCheckMarkWrapper,
  ColorStyledSpan,
  GenresSelectItem,
  GenresSelectItemAnimation,
  Label,
} from './styles'

const SelectGenres: FunctionComponent<SelectGenresProps> = ({
  selectedGenres,
  setSelectedGenres,
  allGenres,
  campaignType,
  campaignId,
  onMobileSearchOpen,
  hidePlaylistsCount,
}) => {
  const { t } = useTranslation()

  //  eslint-disable-next-line @typescript-eslint/no-explicit-any
  const selectRef = useRef<any>(null)
  const isMobile = useMediaQuery({ maxWidth: 576 })

  const userId = useSelector(getUserId)
  const isFirstCampaign = useSelector(getIsFirstCampaign)
  const campaignDetails: CampaignToSchedule = useSelector(getCampaignToSchedule)
  const amountOfCampaigns = useSelector(getAmountOfCampaigns)
  const type =
    isFirstCampaign === undefined || amountOfCampaigns === 1 ? 'first' : 'basic'

  const [selectedStyleGenresId, setSelectedStyleGenresId] = useState(null)
  const [inputValueGenres, setInputValueGenres] = useState('')
  const [searchValueGenres, setSearchValueGenres] = useState('')

  const handleInputChangeGenres = characterEntered => {
    setInputValueGenres(characterEntered)
    characterEntered && setSearchValueGenres(characterEntered)
  }

  const onChangeSelectGenres = (selectedOptions, { action, option }) => {
    setSearchValueGenres('')
    setInputValueGenres('')
    if (action === ActionsForSelectGenresAndLanguagesEnum.SELECT_OPTION) {
      setSelectedStyleGenresId(option.value)
      locationEvent()
      genreAddedEventSchedulingCampaign(
        campaignDetails.type,
        option.value,
        option.label,
        campaignType,
        userId,
        campaignId,
        campaignDetails.type === 'first' ? 1 : amountOfCampaigns
      )

      // TODO
      setTimeout(() => {
        setSelectedGenres(selectedOptions)
        setSelectedStyleGenresId(null)
      }, 500)
    } else if (
      (action === ActionsForSelectGenresAndLanguagesEnum.REMOVE_VALUE ||
        action === ActionsForSelectGenresAndLanguagesEnum.POP_VALUE) &&
      selectedGenres.length !== selectedOptions.length
    ) {
      const deletedGenre = selectedGenres.filter(
        genre => !selectedOptions.includes(genre)
      )?.[0]

      genreRemovedEventSchedulingCampaign(
        campaignDetails.type,
        deletedGenre.value,
        deletedGenre.label,
        campaignType,
        userId,
        campaignId
      )
      setSelectedGenres(selectedOptions)
    } else {
      setSelectedGenres(selectedOptions)
    }
  }

  const mappedListedItems = useMemo(
    () =>
      allGenres.map(item => ({
        value: item.id,
        label:
          item.genre_name.slice(0, 1).toUpperCase() + item.genre_name.slice(1),
        playlistsCount: item.playlists_count,
        placeholder: item.placeholder,
        isDisabled: item.isDisabled,
      })),

    [allGenres]
  )

  const formatOptionLabelGenres = (
    { label, value, playlistsCount, placeholder },
    { inputValue, selectValue }
  ) => {
    const inputLength = inputValue.length

    const index = label.toLowerCase().indexOf(inputValue.toLowerCase())
    const selectValueLabel = selectValue.map(item => item.label)

    if (selectValueLabel.includes(label)) {
      return <div>{label}</div>
    }

    if (selectedStyleGenresId === value) {
      return (
        <GenresSelectItemAnimation>
          <IconCheckMarkWrapper>
            <IconCheckMark />
          </IconCheckMarkWrapper>

          <Label isPlaceholder={placeholder}>
            {label.slice(0, index)}
            <strong>
              {index === 0
                ? inputValueGenres.slice(0, 1).toUpperCase() +
                  inputValueGenres.slice(1)
                : inputValueGenres}
            </strong>
            {label.slice(index + inputLength)}
          </Label>
          {!placeholder && !hidePlaylistsCount && (
            <ColorStyledSpan>
              {!playlistsCount ? 0 : playlistsCount}&nbsp;
              {t('scheduleCampaignPage.playlists')}
            </ColorStyledSpan>
          )}
        </GenresSelectItemAnimation>
      )
    }

    if (selectedStyleGenresId !== value && index === -1) {
      return (
        <GenresSelectItem>
          <Label isPlaceholder={placeholder}>{label}</Label>
          {!placeholder && !hidePlaylistsCount && (
            <span>
              {!playlistsCount ? 0 : playlistsCount}&nbsp;
              {t('scheduleCampaignPage.playlists')}
            </span>
          )}
        </GenresSelectItem>
      )
    }

    return (
      <GenresSelectItem>
        <Label isPlaceholder={placeholder}>
          {label.slice(0, index)}
          <strong style={index === 0 ? { textTransform: 'capitalize' } : null}>
            {inputValueGenres}
          </strong>
          {label.slice(index + inputLength)}
        </Label>
        {!placeholder && !hidePlaylistsCount && (
          <span>
            {!playlistsCount ? 0 : playlistsCount}&nbsp;
            {t('scheduleCampaignPage.playlists')}&nbsp;
          </span>
        )}
      </GenresSelectItem>
    )
  }

  const onMenuOpen = async () => {
    await new Promise(resolve => setTimeout(resolve, 10))

    if (isMobile && selectRef.current.state.menuIsOpen) {
      onMobileSearchOpen()
      setTimeout(() => window.scrollTo(0, 0), 200)
    }
  }

  const filterHandler = ({ label }: { label: string }, inputValue: string) =>
    label
      .toLowerCase()
      .includes(inputValue.toLowerCase() || searchValueGenres.toLowerCase())

  useContainerSize(selectRef)

  return (
    <>
      <Select
        ref={selectRef}
        isMulti
        // menuIsOpen
        menuShouldBlockScroll
        menuPortalTarget={document.body}
        styles={
          isMobile
            ? { ...customStyles, ...mobileCustomStyles }
            : { ...customStyles }
        }
        options={isMobile ? [] : mappedListedItems}
        placeholder={t('createCampaignPage.startTypingGenreName')}
        classNamePrefix="multi-select"
        closeMenuOnSelect={false}
        blurInputOnSelect={false}
        value={selectedGenres}
        label={t('createCampaignPage.genreName')}
        inputValue={inputValueGenres}
        isSearchable={!isMobile}
        filterOption={filterHandler}
        components={{ DropdownIndicator, MenuList }}
        formatOptionLabel={formatOptionLabelGenres}
        onInputChange={handleInputChangeGenres}
        onChange={onChangeSelectGenres}
        onMenuOpen={onMenuOpen}
      />
    </>
  )
}

export default SelectGenres
